<template>
  <v-dialog v-model="dialog" persistent max-width="900" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text small color="info" rounded v-on="on" v-bind="attrs"
        >Detalhes</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold primary--text"
        >Detalhes</v-card-title
      >
      <v-card-subtitle class="green lighten-4 font-weight-bold primary--text">{{
        limite.categoria
      }}</v-card-subtitle>
      <v-card-text>
        <v-data-table :items="limite.detalhes" :headers="headers" class="mt-4">
          <template v-slot:[`item.valor`]="{ item }">
            {{ formatarMoeda(item.valor) }}
          </template>
          <template v-slot:[`item.baixas`]="{ item }">
            {{ formatarMoeda(item.baixas) }}
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            {{ formatarMoeda(item.saldo) }}
          </template>
          <template v-slot:[`item.produtos`]="{ item }">
            <compras-consumo :compra="item.id" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          small
          min-width="80"
          rounded
          @click="dialog = false"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatMoeda } from "@/global";
import ComprasConsumo from "../../../components/ComprasConsumo.vue";

export default {
  props: {
    limite: Object,
  },
  components: {
    ComprasConsumo,
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Estabelecimento", value: "descfilial" },
      { text: "Emissão", value: "emissao" },
      { text: "Valor", value: "valor" },
      { text: "Baixas", value: "baixas" },
      { text: "Saldo", value: "saldo" },
      { text: "Produtos", value: "produtos" },
    ],
  }),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>